import { render, staticRenderFns } from "./RegionHomePage.vue?vue&type=template&id=35321dbe&scoped=true&"
import script from "./RegionHomePage.vue?vue&type=script&lang=js&"
export * from "./RegionHomePage.vue?vue&type=script&lang=js&"
import style0 from "./RegionHomePage.vue?vue&type=style&index=0&id=35321dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35321dbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
